import 'css-chunksrc/client/pages/projectPage/budgetPage/styles.scss';export default {
  "budgetPage": "_budgetPage_160iy_1",
  "main": "_main_160iy_9",
  "menu": "_menu_160iy_16",
  "button": "_button_160iy_25",
  "icon": "_icon_160iy_45",
  "iconBox": "_iconBox_160iy_53",
  "row": "_row_160iy_62",
  "slantedRow": "_slantedRow_160iy_79",
  "monitoring": "_monitoring_160iy_90",
  "costsBreakdownByResourceType": "_costsBreakdownByResourceType_160iy_94",
  "exportButton": "_exportButton_160iy_98"
};